export const Mention = ({ width, height, viewBox, styles, fill }) => {
  return (
    <svg
      width={width || '40'}
      height={height || '40'}
      viewBox={viewBox || '0 0 40 40'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.8336 14.1664C22.6118 10.9445 17.3882 10.9445 14.1664 14.1664C10.9445 17.3882 10.9445 22.6118 14.1664 25.8336C17.3882 29.0555 22.6118 29.0555 25.8336 25.8336C26.1265 25.5407 26.6014 25.5407 26.8943 25.8336C27.1872 26.1265 27.1872 26.6014 26.8943 26.8943C23.0867 30.7019 16.9133 30.7019 13.1057 26.8943C9.2981 23.0867 9.2981 16.9133 13.1057 13.1057C16.9133 9.2981 23.0867 9.2981 26.8943 13.1057C28.798 15.0094 29.75 17.5059 29.75 20C29.75 20.975 29.4545 21.8866 28.941 22.5713C28.4273 23.2563 27.6603 23.75 26.75 23.75C25.8462 23.75 25.0837 23.2633 24.57 22.5859C23.668 24.1767 21.9593 25.25 20 25.25C17.1005 25.25 14.75 22.8995 14.75 20C14.75 17.1005 17.1005 14.75 20 14.75C21.469 14.75 22.7971 15.3534 23.75 16.3258V16.25C23.75 15.8358 24.0858 15.5 24.5 15.5C24.9142 15.5 25.25 15.8358 25.25 16.25V20C25.25 20.6818 25.4582 21.2703 25.759 21.6713C26.0596 22.0721 26.4177 22.25 26.75 22.25C27.0823 22.25 27.4404 22.0721 27.741 21.6713C28.0418 21.2703 28.25 20.6819 28.25 20C28.25 17.8875 27.4447 15.7774 25.8336 14.1664ZM23.75 20C23.75 17.9289 22.0711 16.25 20 16.25C17.9289 16.25 16.25 17.9289 16.25 20C16.25 22.0711 17.9289 23.75 20 23.75C22.0711 23.75 23.75 22.0711 23.75 20Z"
        fill={fill || '#555555'}
      />
    </svg>
  );
};
